// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import ContractVehicleShape from './prop_shapes/contract_vehicle'

class ContractVehicles extends React.Component {
  renderContractVehicle = contractVehicle => (
    <span className='pro-label blue' key={`contractVehicle-${contractVehicle.id}`}>
      {contractVehicle.name}
    </span>
  )

  render () {
    return (
      <div className='content'>
        <div className='small-12 cell'>
          {this.props.contractVehicles.map(cv => this.renderContractVehicle(cv))}
        </div>
      </div>
    )
  }
}

ContractVehicles.propTypes = {
  contractVehicles: PropTypes.arrayOf(ContractVehicleShape)
}

export default ContractVehicles
